import APIV2 from "lib/APIV2";
import Constant from "lib/Constant";
import Event from "lib/Event";
import PubSub from "lib/PubSub";
import StringUtils from "lib/StringUtils";
import React from "react";
import NumberFormat from "react-number-format";
import { withRouter } from "react-router";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Row,
  Spinner,
  Badge,
} from "reactstrap";
import Alert from "reactstrap/lib/Alert";
import { SelectPicker } from "rsuite";
import _ from "underscore";
import CustomerOpenActivitiesWidget from "./CustomerOpenActivitiesWidget";
import CustomerUnclaimedBoxWidget from "./CustomerUnclaimedBoxWidget";

class CustomerHoldDetailsWidget extends React.Component {
  state = {
    expand: false,
    phone: {
      value: "",
    },
    name: "",
    email: "",
    reasonOptions: [
      {
        value: "Reached Goal",
        label: "Reached Goal",
      },
      {
        value: "Product / Experience Issues",
        label: "Product / Experience Issues",
      },
      {
        value: "Financial Issues",
        label: "Financial Issues",
      },
      {
        value: "Extended Travel",
        label: "Extended Travel",
      },
      {
        value: "Relocating",
        label: "Relocating",
      },
      {
        value: "Excessive Meals",
        label: "Excessive Meals",
      },
      {
        value: "Other",
        label: "Other",
      },
    ],
  };

  updateReason() {
    this.setState({ locationSubmitting: true });
    APIV2.updateCustomerHoldReason(
      this.props?.customer?.storeID,
      this.props?.customer?._id,
      this.state.selectedReason
    )
      .then(
        (data) => {
          PubSub.publish(Event.CUSTOMER.MODIFIED, data.data.customer);

          this.setState({ modifyLocation: false });
        },
        (e) => {
          this.setError(
            "error",
            "Could not update customer, please try again."
          );
        }
      )
      .finally(() => {
        this.setState({ locationSubmitting: false });
      });
  }

  updateCoach() {
    this.setState({ coachSubmitting: true });

    APIV2.updateCustomerHoldNotes(
      this.props.customer?.storeID,
      this.props?.customer?._id,
      this.state.notes
    )
      .then(
        (data) => {
          PubSub.publish(Event.CUSTOMER.MODIFIED, data.data.customer);

          this.setState({ modifyCoach: false });
        },
        (e) => {
          this.setError(
            "error",
            "Could not update customer, please try again."
          );
        }
      )
      .finally(() => {
        this.setState({ coachSubmitting: false });
      });
  }

  handleInputChange(e) {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  }

  setError(id, message = "") {
    if (!message) {
      this.setState({ [id]: "" });

      return;
    }

    this.setState({ [id]: message });

    setTimeout(() => {
      this.setError(id);
    }, 4000);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {}

  render() {
    return (
      <>
        <Card
          className={`${this.props.flat ? "border-0" : "border shadow"} mb-4`}
        >
          <CardHeader>
            <Row className="align-items-center">
              <div className="col">
                <h3 className="mb-0">Hold Details</h3>
              </div>
            </Row>
          </CardHeader>
          {this.props.loading ? (
            <CardBody>
              <Spinner size="sm" color="dark" className="mr-2" /> Loading...
            </CardBody>
          ) : (
            <>
              <CardBody className="bg-transparent p-0">
                <div className="px-4 py-3 border-bottom">
                  <Row className="align-items-center">
                    <Col xs="auto" className="font-weight-bold text-dark">
                      Reason:
                    </Col>
                    <Col xs="" className="pl-0">
                      {!this.state.modifyLocation ? (
                        <>
                          {this.props.customer?.subscription?.holdReason
                            ? this.props.customer?.subscription?.holdReason
                            : "--"}
                        </>
                      ) : null}
                    </Col>
                    <Col xs="auto">
                      {this.state.modifyLocation ? (
                        <>
                          <Button
                            onClick={() => {
                              this.setState({ modifyLocation: false });
                            }}
                            size="sm"
                            color="secondary"
                            outline
                            disabled={this.state.locationSubmitting}
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              this.updateReason();
                            }}
                            disabled={this.state.locationSubmitting}
                            size="sm"
                            color="primary"
                          >
                            {this.state.locationSubmitting ? (
                              <>
                                <Spinner size="sm" color="white" />
                              </>
                            ) : (
                              <>Save</>
                            )}
                          </Button>
                        </>
                      ) : (
                        <Button
                          onClick={() => {
                            this.setState({
                              modifyLocation: true,
                              selectedReason:
                                this.props.customer?.subscription?.holdReason,
                            });
                          }}
                          size="sm"
                          color="secondary"
                          outline
                        >
                          Edit
                        </Button>
                      )}
                    </Col>
                    {this.state.modifyLocation ? (
                      <Col xs="12" className="mt-3">
                        <SelectPicker
                          placement="auto"
                          cleanable={true}
                          size="md"
                          placeholder="Select A Reason"
                          data={this.state.reasonOptions}
                          style={{}}
                          value={this.state.selectedReason}
                          block
                          onChange={(val) => {
                            this.setState({ selectedReason: val });
                          }}
                        />
                      </Col>
                    ) : null}
                  </Row>
                </div>
                <div className="px-4 py-3 border-bottom">
                  <Row className="align-items-center">
                    <Col xs="">
                      <div className="font-weight-bold text-dark">
                        Additional Notes:
                      </div>
                    </Col>

                    <Col xs="auto">
                      {this.state.modifyCoach ? (
                        <>
                          <Button
                            onClick={() => {
                              this.setState({ modifyCoach: false });
                            }}
                            size="sm"
                            outline
                            color="secondary"
                            disabled={this.state.coachSubmitting}
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              this.updateCoach();
                            }}
                            disabled={this.state.coachSubmitting}
                            size="sm"
                            color="primary"
                          >
                            {this.state.coachSubmitting ? (
                              <>
                                <Spinner size="sm" color="white" />
                              </>
                            ) : (
                              <>Save</>
                            )}
                          </Button>
                        </>
                      ) : (
                        <Button
                          onClick={() => {
                            this.setState({
                              modifyCoach: true,
                              notes:
                                this.props.customer?.subscription?.holdNotes,
                            });
                          }}
                          size="sm"
                          color="secondary"
                          outline
                        >
                          Edit
                        </Button>
                      )}
                    </Col>
                    {this.state.modifyCoach ? (
                      <Col xs="12" className="mt-3">
                        <Input
                          type="textarea"
                          name="notes"
                          onChange={this.handleInputChange.bind(this)}
                          placeholder="Enter notes"
                          value={this.state.notes}
                        ></Input>
                      </Col>
                    ) : (
                      <Col xs="12" className="pt-3">
                        {this.props.customer?.subscription?.holdNotes
                          ? this.props.customer?.subscription?.holdNotes
                          : "--"}
                      </Col>
                    )}
                  </Row>
                </div>
              </CardBody>
            </>
          )}
        </Card>
      </>
    );
  }
}

export default withRouter(CustomerHoldDetailsWidget);
